import React, { createContext, useContext, useState } from 'react';

/**
 * Multi-workspace was a Team-tier subscription feature. Subscriptions are
 * retired, so the workspace list is always empty. The context is kept as a
 * shim so legacy consumers (Workspaces.jsx, Users.jsx, ClientSelector.jsx)
 * keep working without removal in lockstep.
 */
const ClientContext = createContext(null);

export function ClientProvider({ children }) {
  const [activeClient, setActiveClient] = useState(null);
  const value = {
    activeClient,
    setActiveClient,
    clients: [],
    refreshClients: () => {},
  };

  return (
    <ClientContext.Provider value={value}>
      {children}
    </ClientContext.Provider>
  );
}

export function useClient() {
  const context = useContext(ClientContext);
  if (context === undefined || context === null) {
    throw new Error('useClient must be used within a ClientProvider');
  }
  return context;
}
